export default __webpack_public_path__ + "static/chess--mobile-5a1dd15beb844d0f95a30e52d0c009d4.webp";